// Helpers de elegibilidade por data de cadastro
export function registeredByMonth(student, monthIso) {
  // monthIso: "YYYY-MM"
  if (!monthIso) return true;
  const created = (student?.created_at || "").slice(0, 7);
  if (!created) return true; // se não tem created_at, considera elegível
  return created <= monthIso;
}

export function registeredByDate(student, dateIso) {
  // dateIso: "YYYY-MM-DD"
  if (!dateIso) return true;
  const created = (student?.created_at || "").slice(0, 10);
  if (!created) return true;
  return created <= dateIso;
}
